// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["public/static/css/index"], () => (__webpack_require__("./src/public/js/index.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["public/static/css/index"], () => (__webpack_require__("./src/public/sass/index.sass")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
